<template>
  <div data-tab-name="Templates">
    <div
      class="button"
      name="right_nav_button"
      v-aha-emit-action="{ user_input: 'Templates' }"
      @click.stop="handleClick"
    >
      <aha-icon
        name="inspiration"
        :width="24"
        :height="24"
        viewBox="0 0 24 24"
        class="button-icon"
      ></aha-icon>
      <p class="button-label">
        {{ $i18nPresenter.t('Templates') }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'TemplateLibraryTrigger',
  methods: {
    ...mapActions(['setShowModalTemplateLibraryAction']),
    handleClick() {
      this.setShowModalTemplateLibraryAction(true)
    },
  },
}
</script>

<style lang="scss" scoped>
.button {
  @apply bg-base-0;
  @apply rounded-lg;
  @apply font-bold text-center p-2 mt-0 mx-1 mb-2 cursor-pointer;
  width: 88px;
  transition: all 0.1s ease-in-out;
  &:hover:not(.disabled) {
    @apply hover:bg-secondary-15;
  }
  &.active:not(.disabled) {
    @apply bg-primary-90 text-base-0;
    .button-icon {
      @apply text-base-0;
    }
  }
  &.disabled {
    @apply cursor-not-allowed;
  }
}
.button-icon {
  @apply mb-1 text-secondary-100;
}
.button-label {
  @apply w-full break-words;
  hyphens: auto;
  word-break: break-word;
}
</style>
